import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {JOB_POST, JOB_POST_FORM} from "../../../Config/ApiUrl";
import {axiosPatch, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {JobPositionFilterMixin,UserFilterMixin,SkillZoneFilterMixin} from "../FilterMixin"
import {formattedDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin,JobPositionFilterMixin,UserFilterMixin,SkillZoneFilterMixin],
    data() {
        return {
            options: {
                name: this.$t('job_post.title'),
                url: JOB_POST,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'description',
                        isVisible: true,
                        modifier: (description) => {
                            return description && description.length > 15 ? description.substring(0, 15) + '...' : description;
                        }
                    },
                    {
                        title: this.$t('JobPosition'),
                        type: 'custom-html',
                        key: 'job_position',
                        isVisible: true,
                        modifier: (job_position) => {
                            return job_position ? job_position.title ? job_position.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('manager'),
                        type: 'custom-html',
                        key: 'manager',
                        isVisible: true,
                        modifier: (manager) => {
                            return manager ? manager.full_name ? manager.full_name : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('Skill'),
                        type: 'custom-html',
                        key: 'skill',
                        isVisible: true,
                        modifier: (skill) => {
                            return skill ? skill.title ? skill.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('StartDate'),
                        type: 'text',
                        key: 'start_date',
                        isVisible: true,
                        modifier: (value) => {
                            return formattedDate(value);
                        }
                    },
                    {
                        title: this.$t('EndDate'),
                        type: 'text',
                        key: 'end_date',
                        isVisible: true,
                        modifier: (value) => {
                            return formattedDate(value);
                        }
                    },
                    {
                        title: this.$t('Vacancy'),
                        type: 'text',
                        key: 'vacancy',
                        isVisible: true,
                        modifier: (vacancy) => {
                            return vacancy !== undefined ? vacancy : '-';
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('JobPosition'),
                        type: "multi-select-filter",
                        key: "jobPositions",
                        option: [],
                        listValueField: 'title',
                        permission: !!this.$can('view_job_position')
                    },
                    {
                        title: this.$t('manager'),
                        type: "multi-select-filter",
                        key: "users",
                        option: [],
                        listValueField: 'full_name',
                        permission: !!this.$can('view_users')
                    },
                    {
                        title: this.$t('skill'),
                        type: "multi-select-filter",
                        key: "skills",
                        option: [],
                        listValueField: 'title',
                        permission: !!this.$can('view_skill_zones')
                    },
                    {
                        title: this.$t('StartDate'),
                        type: "range-picker",
                        key: "startDate",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('EndDate'),
                        type: "range-picker",
                        key: "endDate",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: JOB_POST,
                    },
                    {
                        title: this.$t('Link'),
                        type: 'custom',
                        name: 'copy_link',
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-job-post-modal',
                        modalId: 'job-post-modal',
                        url: JOB_POST,
                        name: 'edit',
                        modifier: row => this.$can('update_job_post')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'job-post-modal',
                        url: JOB_POST,
                        name: 'delete',
                        modifier: row => this.$can('delete_job_post')
                    }
                ],
            }
        }
    },
}
